<template>
  <b-modal size="lg" modal-class="mc-modal-right" title="Parameter Laporan" id="modal-parameter">
    <div class="mc-modal__filter">
      <h5 class="mb-3">Geolokasi Rute</h5>
      <div class="mc-modal__filter-item">
        <label class="mt-3">Periode Laporan</label>
        <date-picker
          v-model="periode"
          :placeholder="$t('global.action.selectDate')"
          format="DD MMM YYYY"
          value-type="YYYY-MM-DD"
          :shortcuts="makeShortcuts"
          range-separator=" - "
          range
          @input="changeDateRange"
          :disabled="isLayoutEdit"
          :confirm="true"
          :confirm-text="$t('global.action.apply')"
          ref="periodePicker"
        >
          <template #footer>
            <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">{{
              $t('global.action.cancel')
            }}</b-button>
          </template>
        </date-picker>
      </div>
      <div class="mc-modal__filter-item">
        <label class="mt-3">Geolokasi Mulai</label>
        <multiselect
          v-model="geoStartModel"
          :options="geoStartOptions"
          label="name"
          placeholder="Geolokasi Mulai"
        ></multiselect>
      </div>
      <div class="mc-modal__filter-item">
        <label class="mt-3">Geolokasi Selesai</label>
        <multiselect
          v-model="geoEndModel"
          :options="geoEndOptions"
          label="name"
          placeholder="Geolokasi Mulai"
        ></multiselect>
      </div>
      <div class="mc-modal__filter-item">
        <label class="mt-3">Geolokasi yang Dilewati</label>
        <multiselect
          v-model="geoWayModel"
          :options="geoWayOptions"
          label="name"
          placeholder="Geolokasi Mulai"
          multiple
        ></multiselect>
      </div>
    </div>
    <template #modal-footer>
      <div class="mc-modal__filter-footer">
        <div class="d-flex flex-row-reverse">
          <div>
            <b-button variant="outline-primary" class="me-2" @click="cancelModal()">{{
              $t('global.action.cancel')
            }}</b-button>
            <b-button variant="primary" @click="onSubmit">{{ $t('global.action.apply') }}</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      geoStartModel: null,
      geoStartOptions: ['Surabaya', 'Jogja', 'Jakarta'],
      geoEndModel: null,
      geoEndOptions: ['Surabaya', 'Jogja', 'Jakarta'],
      geoWayModel: null,
      geoWayOptions: ['Surabaya', 'Jogja', 'Jakarta'],
    }
  },
  methods: {
    cancelModal() {
      this.$bvModal.hide('modal-parameter')
    },
    closeCalendar() {
      this.$refs.periodePicker.defaultOpen = false
    },
  },
}
</script>
